<template>
  <div
    v-loading="loading"
    class="hello"
    element-loading-text="正在注册"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255,255,255, 0.2)"
  >
    <el-row v-if="successShow">
      <img src="../assets/apperweima.jpg">
      <h4> 注册已经成功，请扫描上方二维码关注冷链云公众号，登录即可使用。</h4>
    </el-row>
    <el-row style="text-align: center;">
      <img src="../assets/logo.png">
    </el-row>
    <el-form v-if="!successShow" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
      <el-form-item ref="phoneForm" label="手机号码" prop="phone">
        <el-input v-model="ruleForm.phone" />
      </el-form-item>
      <el-form-item label="验证号码" prop="verification">
        <el-col :span="12">
          <el-input v-model="ruleForm.verification" />
        </el-col>
        <el-col :span="12">
          <el-button v-show="show" type="primary" plain @click="SendVerificationCode('ruleForm')">
            发送验证码
          </el-button>
          <el-tag v-show="!show" style=" width: 100%; height:40px; font-size: 30px; line-height:40px" type="danger">
            {{ count }} s
          </el-tag>
        </el-col>
      </el-form-item>
      <el-form-item label="用户姓名" prop="userName">
        <el-input v-model="ruleForm.userName" />
      </el-form-item>
      <el-form-item label="登录名" prop="registerName">
        <el-input v-model="ruleForm.registerName" :disabled="true" />
      </el-form-item>
      <el-form-item label="登录密码" prop="Password">
        <el-input v-model="ruleForm.Password" type="password" />
      </el-form-item>
      <el-form-item label="确认密码" prop="affirmPassword">
        <el-input v-model="ruleForm.affirmPassword" type="password" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">
          立即注册
        </el-button>
        <el-button @click="resetForm('ruleForm')">
          重置
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// import webapi from '../utils/HttpApi.js'

import request from '../utils/request.js'
export default {
  name: 'Register',
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.Password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      successShow: false,
      show: true,
      count: '',
      timer: null,
      ruleForm: {
        userCompany: '',
        userName: '',
        registerName: '',
        Password: '',
        affirmPassword: '',
        phone: '',
        verification: ''
      },
      rules: {
        userName: [
          // { min: 3, max: 5, message: '长度在 2 到 5 个中文字符', trigger: 'blur' }
        ],
        registerName: [
          { required: true, message: '请输入登录名称', trigger: 'blur' }
        ],
        Password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        affirmPassword: [
          { required: true, message: '确认密码不能为空', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'change' },
          { validator: checkPhone, trigger: 'blur' }
        ],
        verification: [
          { required: true, message: '验证码不能为空', trigger: 'change' }
        ]

      }
    }
  },
  computed: {
    phone() {
      return this.ruleForm.phone
    }
  },
  watch: {
    phone(val) {
      this.ruleForm.registerName = val
    }
  },
  mounted() {
    this.ruleForm.userCompany = this.GetUrlParam()
    console.log(this.ruleForm.userCompany)
  },
  methods: {
    submitForm(formName) {
      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request({
            url: '/api/register',
            method: 'post',
            data: {
              'appId': 174,
              'clientId': 1030,
              'password': this.ruleForm.Password,
              'userCompany': this.ruleForm.userCompany,
              'userMobile': this.ruleForm.phone,
              'userName': this.ruleForm.userName,
              'userNo': this.ruleForm.registerName,
              'userVerifyCode': this.ruleForm.verification
            }
          }).then(res => {
            if (res.data.data === -1) {
              this.$message({
                message: '当前登录名已经存在，请修改后保存',
                type: 'warning',
                duration: 0
              })
            } else if (res.data.data === -2) {
              this.$message({
                message: '验证吗不正确我！',
                type: 'warning'
              })
            } else if (res.data.data === -3) {
              this.$message({
                message: '登录名已经被注册，请重新填写！',
                type: 'warning'
              })
            } else if (res.data.data === 1) {
              this.$message({
                message: '注册成功',
                type: 'success'
              })
              this.successShow = true
            } else {
              this.$message({
                message: '注册失败，错误消息:' + res.data.message,
                type: 'error'
              })
            }
          })
        } else {
          return false
        }
      })
      this.loading = false
    },
    SendVerificationCode(formName) {
      this.$refs[formName].validateField('phone', (valid) => {
        if (valid !== '') {
          return false
        } else {
          request({
            url: '/api/sendVerifyCode',
            method: 'post',
            data: 'userMobile=' + this.ruleForm.phone
          }).then(res => {
            console.log(res.data)
            if (res.data.data >= 0) {
              this.$message({
                message: '手机验证成功，短信已经发送到你的手机。',
                type: 'success'
              })
              const TIME_COUNT = 60
              if (!this.timer) {
                this.count = TIME_COUNT
                this.show = false
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--
                  } else {
                    this.show = true
                    clearInterval(this.timer)
                    this.timer = null
                  }
                }, 1000)
              }
            } else if (res.data.data === -1) {
              this.$message({
                message: '手机号码已经注册，请检查手机号码是否正确',
                type: 'warning'
              })
            } else if (res.data.data === -2) {
              this.$message({
                message: '发送过于频繁',
                type: 'warning'
              })
            } else if (res.data.data === -3) {
              this.$message({
                message: '登录名已被注册，请重新填写',
                type: 'warning'
              })
            } else {
              this.$message({
                message: '发送验证码失败，请点击重新发送',
                type: 'error'
              })
            }
          })
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    GetUrlParam() {
      var url = document.location.toString()
      var arrObj = url.split('?')

      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split('&')
        var arr
        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split('=')
          if (arr !== null && arr[0] === 'UserCompany') {
            return arr[1]
          }
        }
        return ''
      } else {
        return ''
      }
    }
  }
  // components:{
  //   verificationCodeBut
  // }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h4{
  text-indent:2em;
  color: blue;
}
</style>
